import DrillDownInteraction from './drillDown';

export const INTERACTION_MAP = {
  drilldown: DrillDownInteraction,
};
